import { SWRConfiguration } from "swr";

import { GetRequest, KeysMatching } from "./types";
import { QueryParams, useAPI } from "./useAPI";
import { paths as originalPaths } from "../generated-schemas/people";

// Define custom "paths", due to a bug in openapi-typescript: https://github.com/drwpow/openapi-typescript/issues/1003
type PathPattern<
  Pattern extends string,
  Params,
> = Pattern extends `${infer Head}/${infer Rest}`
  ? // Handle recursion
    `${PathPattern<Head, Params>}/${PathPattern<Rest, Params>}`
  : // Single segment
    Pattern extends `{${infer ParamName}}`
    ? // It's a param path segment
      Params extends {
        [_ in ParamName]: infer ParamType extends string | number;
      }
      ? `${ParamType}`
      : string
    : // It's a literal path segment
      Pattern;

type paths = {
  [P in keyof originalPaths as PathPattern<
    P,
    originalPaths[P][keyof originalPaths[P]] extends {
      parameters: { path: infer P };
    }
      ? P
      : never
  >]: originalPaths[P];
};

export type Paths = KeysMatching<paths, GetRequest>;

export const usePeopleAPI = <
  PATH extends Paths,
  ResponseType = paths[PATH]["get"]["responses"][200]["content"]["application/json"],
>(
  path: PATH,
  query?: QueryParams,
  options?: SWRConfiguration
) => {
  return useAPI<ResponseType>(path, query, options);
};
